export default __webpack_public_path__ + "e3e6eb9cdf1f625fc5e6b0d3f3ae44d6.svg";